module.exports = __webpack_public_path__ + "img/rengzhengLog.91a08dc7.png";